import React from 'react'
import { Typography, Grid, Container, Button } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import meow from '../../images/meow.png'

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    margin: '60px auto 0 auto',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(2),
  },
  image: { alignItems: 'center', justifyContent: 'center' },
  title: {
    marginBottom: '20px',
    fontWeight: 500,
    textAlign: 'center',
  },
  subtitle: {
    marginBottom: '20px',
    textAlign: 'center',
  },
  button: {
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: '5px',
    margin: '15px auto',
    width: '50%',
    '&:hover': {
      background: 'linear-gradient(90deg, #92fe9d 0%, #00C9FF 100%)',
    },
    [theme.breakpoints.down('sm')]: {
      width: '75%',
    },
  },
}))

const Welcome = () => {
  const classes = useStyles()
  const history = useHistory()

  const handleMeow = () => {
    history.push('/')
  }
  return (
    <Container component='main' maxWidth='md'>
      <Grid item xs={12} sm={12} className={classes.gridContainer}>
        <img src={meow} alt='meow' height='300' className={classes.image} />
        <Typography variant='h5' className={classes.title}>
          🎉Welcome! ProductHunters 😻
        </Typography>
        <Typography variant='h6' className={classes.subtitle}>
          Sign up today and find or create your own rooms.
        </Typography>
        <Typography variant='h6' className={classes.subtitle}>
          It's FREE Forever!✨
        </Typography>

        <Button
          className={classes.button}
          type='button'
          onClick={handleMeow}
          variant='contained'
        >
          Let's Go 🐱‍🏍
        </Button>
      </Grid>
    </Container>
  )
}

export default Welcome
